// The look the custom field filters share. Tiles and drawer use the filter panel's own dropdown colours, so
// they read as the same family as the panel's other filters; design-system tokens supply the rest.
import Styled from 'styled-components';
import {tokensForThemeProvider} from '@forecast-it/design-system';
import {DropdownElement} from '../../../../web-components/core/dropdown/dropdown.styled';

const {color} = tokensForThemeProvider.sky.sys;

// The panel's dropdown colours, as its menus use them: the open border and highlight, the text, the
// menu's dividers and the hovered row. The design system has no token for any of them.
export const PANEL_ACCENT = '#6e0fea';
export const PANEL_TEXT = '#535353';
export const PANEL_DIVIDER = '#e6e6e6';
// An unselected condition pill: the design's idle control border and body text, which have no tokens.
export const PILL_BORDER = '#d6d6e3';
export const PILL_TEXT = '#232334';
export const PANEL_ROW_HOVER = '#f0e7fc';
// The Custom fields section heading's colour.
export const PANEL_HEADING_TEXT = '#8a8aa3';

export const MUTED_TEXT = color.text.content.auxiliary;
export const NEGATIVE_TEXT = color.text.semantic.error;

// The panel menus' text size.
export const PANEL_FONT_SIZE = '12px';

/** A clickable line of the drawer, like a row of the panel's dropdown menus; tinted while selected. */
export const MenuRow = Styled(DropdownElement)<{selected?: boolean}>`
	justify-content: space-between;
	gap: 8px;
	padding: 7px 12px;
	font-size: ${PANEL_FONT_SIZE};
	line-height: 1.3;
	color: ${({selected}) => (selected ? PANEL_ACCENT : PANEL_TEXT)};
	background-color: ${({selected}) => (selected ? PANEL_ROW_HOVER : 'transparent')};
	outline: none;

	&:focus-visible {
		background-color: ${PANEL_ROW_HOVER};
	}
`;

/** Secondary text: hints, a field's type, a count. */
export const Muted = Styled.span`
	font-weight: 400;
	color: ${MUTED_TEXT};
`;

/** Enter or Space, the keys that press a clickable row or tile. */
export const isPressKey = (key: string): boolean => key === 'Enter' || key === ' ';
